module.exports = require('./$.global').document && document.documentElement;


/*****************
 ** WEBPACK FOOTER
 ** ./~/core-js/modules/$.html.js
 ** module id = 17
 ** module chunks = 0
 **/